import IssuersContainer from "../Issuers/IssuersContainer";

interface InvoicePaymentProps {
    handleNext: (issuerId?: string) => void;
}

const InvoicePaymentComponent = ({ handleNext }: InvoicePaymentProps) => {
	return (
		<IssuersContainer setOpen={() => null} setSelectedIssuer={() => null} handleNext={handleNext} />
	)
};

export default InvoicePaymentComponent;